import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { useDialog } from "@/context/DialogProvider";
import { Plus, Trash2, BookOpen } from "lucide-react";

export default function Knowledge() {
  const { confirm } = useDialog();
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ title: "", content: "", category: "iso_standard" });
  const [err, setErr] = useState("");

  const load = async () => { const { data } = await api.get("/knowledge"); setItems(data.documents || []); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try { await api.post("/knowledge", form); setForm({ title: "", content: "", category: "iso_standard" }); setShow(false); load(); }
    catch (e) { setErr(formatErr(e.response?.data?.detail)); }
  };
  const del = async (id, title) => {
    if (!await confirm({ title: "Remove document?", message: `Remove "${title}" from the knowledge base?`, danger: true, confirmLabel: "Remove" })) return;
    await api.delete(`/knowledge/${id}`); load();
  };

  return (
    <div className="vb-fade-in" data-testid="knowledge-page">
      <div className="flex justify-between mb-6 flex-wrap gap-3">
        <div><h1 className="vb-heading text-3xl mb-1" style={{ color: "var(--vb-text-2)" }}>AI Knowledge Base</h1>
          <p className="opacity-70">Train Claude on your ISO 22000 SOPs, control plans and past CAPAs. Every AI suggestion is grounded in these documents.</p></div>
        <button className="vb-btn" onClick={() => setShow(true)} data-testid="add-knowledge"><Plus size={16} /> Add document</button>
      </div>

      <div className="grid gap-3">
        {items.length === 0 && <div className="vb-card p-6 text-center opacity-70"><BookOpen className="inline mb-2" size={28} /><p>No knowledge documents yet — paste in your HACCP plan, CCP procedures, or past CAPA records to dramatically improve AI suggestions.</p></div>}
        {items.map((d) => (
          <div key={d.id} className="vb-card p-4">
            <div className="flex justify-between items-start gap-3">
              <div>
                <div className="flex items-center gap-2 mb-1"><strong>{d.title}</strong><span className="vb-pill">{d.category.replace("_", " ")}</span></div>
                <p className="text-sm opacity-80 whitespace-pre-wrap" style={{ maxHeight: 80, overflow: "hidden" }}>{d.content.slice(0, 280)}{d.content.length > 280 ? "…" : ""}</p>
                <p className="text-xs opacity-50 mt-2">Added by {d.added_by} · {new Date(d.created_at).toLocaleDateString()}</p>
              </div>
              <button className="vb-btn ghost" onClick={() => del(d.id)}><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>

      {show && (<div className="vb-modal-bg"><div className="vb-modal">
        <h2>Add knowledge document</h2>
        {err && <div className="vb-pill err mb-3">{err}</div>}
        <form onSubmit={submit} className="grid gap-3">
          <input className="vb-input" required placeholder="Title (e.g. HACCP Plan v3)" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="kd-title" />
          <select className="vb-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
            <option value="iso_standard">ISO standard / clause guidance</option>
            <option value="sop">SOP / Procedure</option>
            <option value="past_capa">Past CAPA / case study</option>
            <option value="general">General</option>
          </select>
          <textarea className="vb-input" required rows={10} placeholder="Paste the content (max 50,000 chars)" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} data-testid="kd-content" />
          <div className="flex gap-2 justify-end"><button type="button" className="vb-btn ghost" onClick={() => setShow(false)}>Cancel</button>
            <button type="submit" className="vb-btn" data-testid="kd-submit">Save</button></div>
        </form>
      </div></div>)}
    </div>
  );
}
